import React, { useContext, useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import Select from "react-select";
import buildLink from "../../../urls";
import axios from "axios";
import Cookies from "js-cookie";
import { CompanyContext } from "../../../contexts/companyCotext";
import { LogisticContext } from "../../../contexts/logisticContext";
import Loader from "../../../components/loader";
import MessageAlert from "../../../components/messageAlert";
import hocStarredPage from "../../../components/hocStarredPage";
import { format } from "date-fns";
import { PlaySounds } from "../../../functions/playSounds";
import Header from "../../../components/Header";
import { axiosServer } from "../../../axiosServer";

const Given = () => {
  const [loading, setLoading] = useState(false);
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [logisticSelect, setLogisticSelect] = useState(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessageErr, setShowMessageErr] = useState(false);
  const [constNumPack, setConstNumPack] = useState(0);
  const [orderList, setOrdersList] = useState([]);
  const [orderStatus, setorderStatus] = useState("normal");
  const [numPackage, setNumPackage] = useState(1);
  const [OldOrderId, setOldOrderId] = useState(null);
  const [showPackageFlow, setShowPackageFlow] = useState(true);
  const [splitScanProgress, setSplitScanProgress] = useState(null);
  const orderId = useRef(null);
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];
  const [stateLogistic, dispatchStateLogistic] = useContext(LogisticContext);


  let orderListCookies =
    Cookies.get("ordersHistory") === undefined
      ? []
      : JSON.parse(Cookies.get("ordersHistory"));
  var orderListVar = orderListCookies;

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  const handleRadioChange = (event) => {
    const packageCount = Number(event.target.value);
    setNumPackage(packageCount);
    setConstNumPack(packageCount);
  };

  const handleSetCookies = (list) => {
    Cookies.set("ordersHistory", JSON.stringify(list));
  };

  useEffect(() => {
    orderId.current.focus();
  }, []);

  const syncPackageFlowVisibility = (value = "") => {
    const shouldShowPackageFlow = !value.trim().includes("-");
    setShowPackageFlow(shouldShowPackageFlow);

    if (shouldShowPackageFlow && value.trim()) {
      setSplitScanProgress(null);
    }

    if (!shouldShowPackageFlow) {
      setNumPackage(1);
      setOldOrderId(null);
    }
  };

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
  };

  const handleTrashClick = () => {
    orderId.current.value = "";
    setShowPackageFlow(true);
    setSplitScanProgress(null);
    orderId.current.focus();
  };

  const updateOrderStatus = async (e = "", type = "", orderId = "") => {
    const userID = getUserIdFromLocalStorage();
    const currentDate = new Date();
    const formattedDate = format(currentDate, "dd-MM-yy HH:mm:ss");
    const trimmedOrderId = orderId.trim();
    e.preventDefault();

    if (!trimmedOrderId) {
      setMessage("Please Enter Order Id First");
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return false;
    }

    if (trimmedOrderId.includes("-")) {
      setLoading(true);
      const obj = {
        logistic_id: logisticSelect || "",
        user_id: userID,
        type,
        order_type: orderStatus === "return" ? 1 : 0,
      };

      let url = "";
      if (orderStatus === "normal") {
        obj.order_id = trimmedOrderId;
        url = buildLink("updateOrderV2");
      } else {
        obj.return_order_id = trimmedOrderId;
        url = buildLink("updateReturnOrderV2");
      }

      try {
        const response = await axiosServer.put(url, obj);
        const { success, message: responseMessage, data } = response.data || {};

        updateSplitScanProgress(response?.data?.package_scan ?? data);
        setMessage(responseMessage || "");

        if (data?.current_status === "given") {
          const objtable = {
            date: formattedDate,
            user: stateCom.username,
            id: trimmedOrderId.split("-")[0],
            status: data?.current_status ?? "",
            reason: responseMessage || "",
            success: Boolean(success),
          };
          setOrdersList((prevProducts) => [objtable, ...prevProducts]);

          const updatedOrderListVar = [...orderListVar, objtable];
          handleSetCookies(updatedOrderListVar);
        }

        if (success) {
          setShowMessageSucc(true);
          playSuccessSound();
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          setShowMessageErr(true);
          playErrorSound();
          setTimeout(() => {
            setShowMessageErr(false);
          }, 10000);
        }

        return Boolean(success);
      } catch (error) {
        const errorResponse = error.response?.data || {};
        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: trimmedOrderId,
          status:
            errorResponse?.current_status ??
            errorResponse?.data?.current_status ??
            "",
          reason: errorResponse.message || "Request failed",
          success: false,
        };

        updateSplitScanProgress(errorResponse?.package_scan ?? errorResponse.data);
        setOrdersList((prevProducts) => [objtable, ...prevProducts]);
        setMessage(errorResponse.message || "Request failed");

        const updatedOrderListVar = [...orderListVar, objtable];
        handleSetCookies(updatedOrderListVar);

        setShowMessageErr(true);
        playErrorSound();
        setTimeout(() => {
          setShowMessageErr(false);
        }, 10000);

        return false;
      } finally {
        setLoading(false);
      }
    }

    if (numPackage > 1) {
      if (OldOrderId === trimmedOrderId || !OldOrderId) {
        setNumPackage(numPackage - 1);
        setOldOrderId(trimmedOrderId);
      }
    } else if (
      numPackage === 1 &&
      (OldOrderId === trimmedOrderId || !OldOrderId)
    ) {
      setLoading(true);
      const obj = {
        logistic_id: logisticSelect,
        user_id: userID,
        type: type,
        nb_of_pack: constNumPack,
        upc_id: "",
        item: "",
      };
      var url = "";
      if (orderStatus === "normal") {
        obj.order_id = trimmedOrderId;
        url = buildLink("updateOrder");
      } else {
        obj.return_order_id = trimmedOrderId;
        url = buildLink("updateReturnOrder");
      }

      try {
        const response = await axios.put(url, obj);

        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: trimmedOrderId,
          status: response.data.data.current_status,
          reason: response.data.message,
          success: true,
        };
        setOrdersList((prevProducts) => [objtable, ...prevProducts]);

        orderListVar.push(objtable);
        handleSetCookies(orderListVar);
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        setLoading(false);
        playSuccessSound();
        setMessage(response.data.message);
        setOldOrderId(null);
        return true;
      } catch (e) {
        const objtable = {
          date: formattedDate,
          user: stateCom.username,
          id: trimmedOrderId,
          status: e.response.data.data.current_status,
          reason: e.response.data.message,
          success: false,
        };

        // Update orders list state immutably
        setOrdersList((prevProducts) => [...prevProducts, objtable]);
        setMessage(e.response.message);
        // Ensure we don't mutate the state variable directly
        const updatedOrderListVar = [...orderListVar, objtable];
        handleSetCookies(updatedOrderListVar);

        setLoading(false);

        setShowMessageErr(true);
        setMessage(e.response.data.message);
        playErrorSound();

        setTimeout(() => {
          setShowMessageErr(false);
        }, 10000);

        setOldOrderId(null);
        return false;
      }

    }
  };

  const handleSubmit = async (e) => {
    const scannedOrderId = orderId.current.value.trim();
    syncPackageFlowVisibility(scannedOrderId);
    await updateOrderStatus(e, "given", scannedOrderId);
    orderId.current.value = "";
    orderId.current.focus();
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <Header title={"Given"} />
        </div>
        <div className=" container">
          <div className=" py-3">
            <div>Order Status</div>
            <Select
              placeholder="Order Status"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  outline: "red",
                  padding: "8px 5px",
                }),
              }}
              onChange={(e) => {
                setorderStatus(e.value);
              }}
              options={options}
            />
          </div>
          <div className=" py-3">
            <div>logistics</div>
            <Select
              placeholder="Logistics"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  outline: "red",
                  padding: "8px 5px",
                }),
              }}
              options={stateLogistic.logisticList}
              onChange={(e) => {
                setLogisticSelect(e.value);
              }}
            />
            {showPackageFlow ? (
              <>
                <div className="p-1 mt-3">Number of Packages:</div>
                <div className="space-x-3 flex flex-wrap">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((value) => (
                    <label
                      htmlFor={`pack${value}`}
                      className="flex gap-2 flex-row"
                      key={value}
                    >
                      <input
                        type="radio"
                        id={`pack${value}`}
                        name="number"
                        value={value}
                        onChange={handleRadioChange}
                      />
                      <div>{value}</div>
                    </label>
                  ))}
                </div>
              </>
            ) : (
              splitScanProgress?.remainingPackages > 0 && (
                <>
                  <div className="p-1 mt-3">Scanned:</div>
                  <input
                    value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                    readOnly
                    type="text"
                    className="border mt-1 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Scanned"
                  />
                </>
              )
            )}
          </div>
          <div className="-mt-2 -mb-2">Order ID</div>
          <form onSubmit={handleSubmit} className="gap-2 flex py-3">
            <div className="relative flex-1">
              <input
                ref={orderId}
                type="text"
                onChange={(e) => syncPackageFlowVisibility(e.target.value)}
                className="border-2 w-full rounded-md border-dbase py-2 pr-8 pl-2"
              />
              <FaTrash
                className="absolute top-1/2 transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                onClick={handleTrashClick}
              />
            </div>
            <div className="w-fit cursor-pointer px-5 text-white text-center rounded-md bg-dbase">
              <button className="flex  whitespace-nowrap  items-center justify-center h-full">
                {loading ? (
                  <Loader />
                ) : showPackageFlow && (numPackage > 1 || numPackage === 0) ? (
                  numPackage
                ) : (
                  "Mark as given"
                )}
              </button>
            </div>
          </form>
        </div>
        <div className="container w-full rounded-md text-white flex justify-between ">
          <div className="border w-full flex-1  px-8  text-dgreyBlack border-dblack  py-2 flex items-center justify-center">
            {orderList.filter(order => order.success).length}
          </div>
          <div
            onClick={() => setOrdersList([])}
            className="border cursor-pointer w-full bg-dbase   flex-2  border-dblack  py-2 flex items-center justify-center"
          >
            Reset
          </div>
        </div>
        <div className="w-full mt-3 bg-white p-3 rounded">
          <table className="w-full border-dlabelColor border">
            <thead>
              <tr className=" border-b border-dlabelColor">
                <th className="py-2  border-dlabelColor border-r">Order ID</th>
                <th className="py-2 border-r">Status</th>
                <th className="py-2 border-dlabelColor">Reason</th>
              </tr>
            </thead>
            <tbody>
              {orderList &&
                orderList.map((item) => {
                  return (
                    <tr
                      className={` ${
                        item.success ? "text-dgreen" : "text-dbase"
                      } text-center border-b border-dlabelColor`}
                    >
                      <td className="py-2  border-dlabelColor border-r">
                        {item.id}
                      </td>
                      <td className="py-2  border-dlabelColor border-r">
                        {item.status}
                      </td>
                      <td className="py-2  border-dlabelColor border-r">
                        {item.reason}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <MessageAlert
          message={message}
          type={showMessageErr ? "err" : "succ"}
          showMessg={showMessageErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(Given);
